var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Wearher"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,6c-3.9,0-7.5,2.1-9.1,5.2C10.8,10.4,9.4,10,8,10c-3.9,0-7,3.1-7,7s3.1,7,7,7h13c5.5,0,10-4,10-9   C31,10,26.5,6,21,6z",
    fill: "#607C8B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenClouds);
export default __webpack_public_path__ + "static/media/broken_clouds.971b1abb01ada15daa2539cb74c476ca.svg";
export { ForwardRef as ReactComponent };